import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import {
  SignOut,
} from '../Util/SignOut';

class Signout extends Component {
  constructor(props) {
    super(props);

    this.state = {
     redirectPath: null,
    }
  }

  componentDidMount() {
    SignOut(this.props);
  }

  render() {
    if (this.state.redirectPath) {
      return (
        <Redirect to={this.state.redirectPath} />
      );
    }

    return (
      <div></div>
    );
  }
}

export default Signout;
